<template>
  <div class="case">
    <!-- <img class="banner" src="https://www.xaryxx.com/images/banner/banner1.png" alt=""> -->

    <!-- <img 
    class="banner"
        v-lazy="'https://www.xaryxx.com/images/banner/banner1.png'">
 -->

    <img class="banner" src="../../assets/banner/anli.jpg" alt="" />
    <div class="titleCont">
      <div>CUSTOMER SROTIES</div>
      <div>客户案例</div>
    </div>

    <div class="content">
      <div class="box animate__animated animate__bounceInUp">
        <div @click="detail(item)" class="item" v-for="item in caseList">
          <div class="imgs">
            <img :src="item.url" alt="" />
          </div>
          <div class="infos">
            <div class="name">{{ item.caseTitle }}</div>
            <div class="desc">{{ item.projectDescribe }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { permissions } from "@/api/api";

export default {
  name: "case",
  components: {},
  data() {
    return {
      caseList: [],
      qudaoShow: false,
      deviceShow: false,
    };
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },

  created() {
    this.getpermissions();
    // window.addEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling(e) {
      const winHeight =
        e.target.scrollTop || document.documentElement.scrollTop;
      console.log(winHeight, 4444444444);
      if (winHeight >= 100) {
        this.qudaoShow = true;
      }
    },
    detail(item) {
      this.$router.push({
        path: "/pages/case/detail",
        query: { id: item.id, current: 0 },
      });
    },
    getpermissions() {
      permissions().then((response) => {
        this.caseList = response.rows;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.titleCont {
  > div:first-child {
    font-family: Arial;
    font-weight: normal;
    font-size: 30px;
    color: #333333;
    line-height: 24px;
    margin: 120px 0 36px;
    text-align: center;
  }
  > div:last-child {
    text-align: center;
    font-family: PingFang SC;
font-weight: 400;
font-size: 30px;
color: #333333;
  }
}
.case {
  padding-top: 120px;
  .banner {
    display: block;
    width: 100%;
  }

  .content {
    padding: 99px 0 30px;
    .infos {
      // height: 200px;
      // background: linear-gradient(180deg, #ffffff, #ffede4);
      padding: 0 32px 41px;
      
    }

    .box {
      width: 70%;
      display: flex;
      flex-wrap: wrap;

      margin: 0 auto;

      .item {
        box-shadow: 0px 0px 15px 0px rgba(195,193,192,0.45);
        width: 31.33%;
        // flex: 1;
        // width: 395px;
        overflow: hidden;
        cursor: pointer;
        margin-right: 2%;
        &:nth-child(3n) {
          margin-right: 0;
        }

        .imgs {
          overflow: hidden;
        }

        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
        }

        &:hover {
          .imgs img {
            transform: scale(1.2);
          }
        }

        @keyframes zoom {
          50% {
            transform: scale(1);
          }

          80% {
            transform: scale(1.1);
          }

          100% {
            transform: scale(1);
          }
        }

        margin-bottom: 30px;
        margin-right: 24px;

        .name {
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 23px;
          padding: 27px 0 18px 0;
          text-align: center;
        }

        .desc {
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          min-height: 45px;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/case/index.vue